import React, { Fragment, useState, useEffect,useContext } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import LeadDetail from 'components/sales/leadDetails/createLeadDetail/leadDetail';
import Notfound from 'pages/notfound';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';


const ViewDetails = ({ viewDetails, getDetails, match }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [details, setDetails] = useState(null);
  const [leadId, setleadId] = useState();
  const [teamId, setTeamId] = useState();
  const [isRender, setIsRender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [roleId, setRoleId] = useState(false);

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      let leadTypeId =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type_id;

      if(leadTypeId === undefined){
       leadTypeId = (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type?.id;
      }

      setRoleId(localStorage.getItem('fusion-role'))
      setTeamId(team);
      const requestData = {
        lead_id: leadId,
        lead_type: leadTypeId,
      };

      if (leadId) {
        setIsLoading(true);
        const res = await getDetails(requestData);
        setIsLoading(false);
        if (res === null || res === '') {
          setIsRender(true);
        }
      }
    })();
  }, [getDetails, leadId]);
  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={{
            pathname: `${baseUrl}/business-addresses/${leadId}`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.businessAddresses}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
        <Link
          to={{
            pathname: `${baseUrl}/edit-project/${leadId}`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.editProject}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </Fragment>
    );
  };
  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
    }
    setleadId(match.params.id);
  }, [viewDetails]);
console.log(details);
  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={localization.BacktoList} isLoading={isLoading} 
    Buttons={parseInt(roleId) !== 55 ? headerBtns : ""}
    isGoback>
      <LeadDetail details={details} />
    </Layout>
  );
};

ViewDetails.propTypes = {
  viewDetails: PropTypes.any,
  getDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ViewDetails;
